import { render } from "./TrainingSection.vue?vue&type=template&id=49de1d5e&scoped=true"
import script from "./TrainingSection.vue?vue&type=script&lang=js"
export * from "./TrainingSection.vue?vue&type=script&lang=js"

import "./TrainingSection.vue?vue&type=style&index=0&id=49de1d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49de1d5e"]])

export default __exports__